import { transformPropOrder } from "./keys-transform.mjs";
const positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...transformPropOrder
]);
export {
  positionalKeys
};
